<div class="bz-fab">
    <a  class="bz-fab__btn" [ngStyle]="setButtonStyles()" [ngClass]='additionalClass' [attr.tooltip]="tooltipText | translate | uppercase">
        <i [ngClass]="[icon, transform]"  class="bz-icon"></i>
        <i [ngClass]="[replacementIcon ,transform]"  class="bz-icon"></i>
    </a>
</div>